import { Component } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-top-banner',
  templateUrl: './top-banner.component.html',
  styleUrls: ['./top-banner.component.scss'],
  standalone: true
})
export class TopBannerComponent {

  constructor(private router: Router) { }

  public logoClick(): void {
    this.router.navigate(['account/login']);
  }
}
